import { ConfirmProofOfAddressStepUI } from './ConfirmProofOfAddressStepUI'
import { useConfirmProofOfAddressStep } from './useConfirmProofOfAddressStep'

export const ConfirmProofOfAddressStep = () => {
  const props = useConfirmProofOfAddressStep()

  return <ConfirmProofOfAddressStepUI {...props} />
}
